/**
 * Angular Import.
 */
import { Component, Input, Output, EventEmitter, OnDestroy } from '@angular/core';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';

/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';
/**
 * Import service.
 */
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { DataStorageService } from '../../dataservices/data-storage.service';
import { NewLanguageService } from '../../dataservices/new-language/new-language.service';
/**
 * Constant imports.
 */
import { ACTION_TYPE, CTA_TYPE, PRODUCT_TYPE_CONSTANT, PRODUCT_TYPE_CONSTANT_NAME, SCREEN_NAME } from './../../constants/app.constants';
/**
 * Directive service.
 */
import { ButtonDirective } from './../../directives/ga.directive';
import { ENTRY, EXIT } from 'analytics2.0/dist/core/constants/analytic.interface';

/**
 * Edetail modal.
 */
@Component({
  selector: 'app-edetail-modal',
  templateUrl: './edetail-modal.component.html',
  styleUrls: ['./edetail-modal.component.scss']
})
export class EdetailModalComponent implements OnDestroy {
  /**
   * Show modal variable.
   */
  @Input() showModal: boolean;
  /**
   * Get drug id from edetail drug.
   */
  @Input() drugCompositionId: number;

  /**
   * flag to call default entry exit events
   */
  @Input() toCallDefaultEvents: true;

  /**
   * Modal title.
   */
  @Input() title: string;

  /**
   * Type of modal.
   */
  @Input() modalType: string;

  /**
   * Logo of modal.
   */
  @Input() logo: string;

  @Input() callingFrom: string;
  @Input() drugId: number;
  /**
   * Output function when user close modal.
   */
  @Output() backClicked = new EventEmitter();
  /**
   * Used to store date object.
   */
  public dateObj = new Date();

  public screenName = SCREEN_NAME;
  /**
   *  page name.
   */
  public page_from = this.mls.googleEventText.drug_sample_detail.key8;

  /**
    * Drug session time object.
    */
  public sessiontime = { 'start_time': '', 'end_time': '' };
  /**
   * Drug type from constants.
   */
  public drugType = PRODUCT_TYPE_CONSTANT;

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();
  private startTime: number;


  constructor(public Dss: DataStorageService, public mls: NewLanguageService, private fcs: FunCollectionService,
    private directive_ser: ButtonDirective, private analyticSdk: Analytics) { }

  ngOnInit(): void {
  }


  /**
   * When user click on close or ESC.
   */
  onHidden(): void {
    this.showModal = false;
    this.backClicked.emit();
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
